<!-- 生产企业管理--账号管理 -->
<template>
	<div class="container flex flex-column height-all overflow-hidden">
        <div class="menuPageTitle">
            <span class="pageTitleCur">消息详情</span>
        </div>
        <div>
            <el-button plain class="searchBtnStyle" type="primary" @click="lastReceiveBtn()"  :disabled="queryNoticeDetail.lastReceive.isExist == 0">上一条</el-button>
            <el-button plain class="searchBtnStyle" type="primary" @click="nextReceiveBtn()"  :disabled="queryNoticeDetail.nextReceive.isExist == 0">下一条</el-button>
            <el-button plain class="searchBtnStyle" type="primary" @click="openNoticeList()" >返回列表</el-button>
        </div>
        <div class="queryNoticeDetailDiv">
            <div class="queryTitle">{{queryNoticeDetail.title}}</div>
            <div class="queryAddDate">{{queryNoticeDetail.addDate}}</div>
            <el-divider />
            <div class="rich-text-container" v-html="queryNoticeDetail.content"></div>
        </div>

	</div>
</template>

<script>
	import baseSearch from "@/components/baseSearch";
	import basetable from "@/components/basetable";
	import basedialog from "@/components/basedialog";
	export default {
		name:'userManager',
		inject: ['$http', '$api', '$utils','$userUtils'],
		components: {
			baseSearch,
			basetable,
			basedialog,
		},
		data(){
			return{
                receiveId:'',
                selectNoticeType:'',
                queryNoticeDetail:{
                    lastReceive:{isExist:1},
                    nextReceive:{isExist:1}
                }
			}
		},
        watch: {
            // 监听路由变化（包括参数变化）
            $route(to, from) {
                // 路由参数变化时，重新加载数据
                if(this.$route.query.receiveId){
                    this.receiveId = this.$route.query.receiveId;
                    if(this.$route.query.selectNoticeType){
                        this.selectNoticeType = this.$route.query.selectNoticeType;
                    }
                    this.initData();
                    // this.readNoticeSelect();
                }
            }
        },
		mounted() {
            this.receiveId = this.$route.query.receiveId;
            if(this.$route.query.selectNoticeType){
                this.selectNoticeType = this.$route.query.selectNoticeType;
            }
			this.initData();
            // this.readNoticeSelect();
		},
		methods:{
			/**
			 * 初始化数据
			 */
			initData(){
                this.$nextTick(()=>{
                    this.$http.post(this.$api.queryNoticeDetailApi,{
                        "receiveId":this.receiveId,
                        "selectNoticeType":this.selectNoticeType,
                    }).then(res=>{
                        if(res.code == 200){
                            this.queryNoticeDetail = res.data;
                            this.$emit('call-index', 'queryNoticePreview')
                        }
                    })
                })

			},
            /**
             * 跳转通知列表
             */
            openNoticeList(){
                this.$router.push({
                    path: "/noticeList",
                })
            },
            /**
             * 跳转通知列表
             */
            lastReceiveBtn(){
                this.$router.push({
                    path: "/noticeDetails",
                    query: {"receiveId":this.queryNoticeDetail.lastReceive.receiveId}
                })
                // this.$http.post(this.$api.queryNoticeDetailApi,{
                //     "receiveId":this.queryNoticeDetail.lastReceive.receiveId,
                //     "selectNoticeType":this.selectNoticeType,
                // }).then(res=>{
                //     if(res.code == 200){
                //         this.queryNoticeDetail = res.data;
                //
                //     }
                // })
            },
            /**
             * 跳转通知列表
             */
            nextReceiveBtn(){
                this.$router.push({
                    path: "/noticeDetails",
                    query: {"receiveId":this.queryNoticeDetail.nextReceive.receiveId}
                })
                // this.$http.post(this.$api.queryNoticeDetailApi,{
                //     "receiveId":this.queryNoticeDetail.nextReceive.receiveId,
                //     "selectNoticeType":this.selectNoticeType,
                // }).then(res=>{
                //     if(res.code == 200){
                //         this.queryNoticeDetail = res.data;
                //     }
                // })
            },
            /**
             * 标记已读
             */
            readNoticeSelect(){
                let that = this;
                let receiveIdList = [];
                receiveIdList.push(this.receiveId)
                this.$http.post(this.$api.readNoticeReceiveApi,{
                    receiveIdsJson:JSON.stringify(receiveIdList),
                }).then(res=>{
                    this.$emit('call-index', 'queryNoticePreview')
                })
            },
		}
	}
</script>

<style>
    .mainCont .container{
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 12px;
        box-sizing: border-box;
    }
</style>
<style scoped>
    .menuPageTitle{
        margin-bottom: 20px;
    }
    .searchBtnStyle {
        background: #FFFFFF;
        color: #4A7FF8;
        border-radius: 4px!important;
        border: 1px solid #4A7FF8;
        height: 28px;
        line-height: 28px;
    }
    .queryNoticeDetailDiv{
        margin-top: 20px;
        border: 1px solid #eee;
        width: calc(100% - 10%);
        padding: 30px 5%;
    }
    .queryTitle{
        width: 100%;
        text-align: center;
        font-size: 26px;
        font-weight: 500;
        margin-bottom: 12px;
        font-family: 'Noto Sans SC', sans-serif;
    }
    .queryAddDate{
        width: 100%;
        text-align: center;
    }
    .queryNoticeDetailContainer{

    }
</style>